import ApiMixin from './api'

export default {
  mixins: [ApiMixin],

  methods: {
    async getDashboardMetrics (startDate, endDate, merchantKsuids = []) {
      const response = await this.api({
        url: '/paynetworx_funding/analytics/dashboard_metrics',
        method: 'GET',
        params: {
          start_date: this.formatDateISO(startDate),
          end_date: this.formatDateISO(endDate),
          merchant_ksuids: merchantKsuids
        }
      })

      return response
    },

    async getClientRankings (startDate, endDate, limit = 10, offset = 0, sortBy = null, sortOrder = 'desc', merchantKsuids = []) {
      const response = await this.api({
        url: '/paynetworx_funding/analytics/client_rankings',
        method: 'GET',
        params: {
          start_date: this.formatDateISO(startDate),
          end_date: this.formatDateISO(endDate),
          limit,
          offset,
          sort_by: sortBy,
          sort_order: sortOrder,
          merchant_ksuids: merchantKsuids
        }
      })

      return response
    },

    async getVolumeOverTime (type, merchantIds = [], startDate, endDate, granularity = 'day') {
      const response = await this.api({
        url: '/paynetworx_funding/analytics/volume_over_time',
        method: 'GET',
        params: {
          type,
          merchant_ids: merchantIds,
          start_date: this.formatDateISO(startDate),
          end_date: this.formatDateISO(endDate),
          granularity
        }
      })

      return response
    },

    async getCardTypeBreakdown (startDate, endDate, granularity = 'day', merchantKsuids = []) {
      const response = await this.api({
        url: '/paynetworx_funding/analytics/card_type_breakdown',
        method: 'GET',
        params: {
          start_date: this.formatDateISO(startDate),
          end_date: this.formatDateISO(endDate),
          granularity,
          merchant_ksuids: merchantKsuids
        }
      })

      return response
    },

    async getFundingBatches (params = {}) {
      const response = await this.api({
        url: '/paynetworx_funding/batches',
        method: 'GET',
        params: {
          start_date: params.startDate ? this.formatDateISO(params.startDate) : null,
          end_date: params.endDate ? this.formatDateISO(params.endDate) : null,
          status: params.status || null,
          type: params.type || null,
          search: params.search || null,
          merchant_ids: params.merchantIds || null,
          limit: params.limit || 25,
          offset: params.offset || 0,
          sort_by: params.sortBy || 'date',
          sort_order: params.sortOrder || 'desc'
        }
      })

      return response
    },

    async getBatchTransactions (batchId, entityKsuid, type = null) {
      const response = await this.api({
        url: `/paynetworx_funding/batches/${batchId}/transactions`,
        method: 'GET',
        params: {
          entity_ksuid: entityKsuid,
          type
        }
      })

      return response
    },

    async getTrendsData (startDate, endDate, merchantKsuids = []) {
      const response = await this.api({
        url: '/paynetworx_funding/analytics/trends_data',
        method: 'GET',
        params: {
          start_date: this.formatDateISO(startDate),
          end_date: this.formatDateISO(endDate),
          merchant_ksuids: merchantKsuids
        }
      })

      return response
    },

    async getMerchants (params = {}) {
      const response = await this.api({
        url: '/paynetworx_funding/merchants',
        method: 'GET',
        params: {
          search: params.search || null,
          include_inactive: params.includeInactive || false,
          has_transactions: params.hasTransactions,
          limit: params.limit || 500,
          offset: params.offset || 0,
          sort_by: params.sortBy || 'merchant_name',
          sort_order: params.sortOrder || 'asc'
        }
      })

      return response
    },

    formatDateISO (date) {
      if (!date) return null
      if (typeof date === 'string') return date.split('T')[0]
      return date.toISOString().split('T')[0]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/fundingApi.js